import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, PlusCircle, Shield, TrendingUp, Wrench } from "lucide-react";
import { ChangeItem } from "./ChangeItem";
import { getSectionClass, getSectionTitle } from "./utils";
function getSectionIcon(type) {
    const iconClass = 'h-4 w-4';
    switch(type){
        case 'added':
            return /*#__PURE__*/ _jsx(PlusCircle, {
                className: iconClass
            });
        case 'changed':
            return /*#__PURE__*/ _jsx(TrendingUp, {
                className: iconClass
            });
        case 'fixed':
            return /*#__PURE__*/ _jsx(Wrench, {
                className: iconClass
            });
        case 'security':
            return /*#__PURE__*/ _jsx(Shield, {
                className: iconClass
            });
        case 'breaking':
            return /*#__PURE__*/ _jsx(AlertTriangle, {
                className: iconClass
            });
        default:
            return null;
    }
}
export function ChangeSection({ type, changes, maxVisible }) {
    if (changes.length === 0) return null;
    const visibleChanges = maxVisible ? changes.slice(0, maxVisible) : changes;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-6 last:mb-0",
        children: [
            /*#__PURE__*/ _jsxs("h3", {
                className: `flex items-center gap-2 text-sm font-semibold mb-3 ${getSectionClass(type)}`,
                children: [
                    getSectionIcon(type),
                    getSectionTitle(type)
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "list-none pl-6 space-y-2.5",
                children: visibleChanges.map((change, idx)=>/*#__PURE__*/ _jsx(ChangeItem, {
                        change: change
                    }, idx))
            })
        ]
    });
}
